export default "__VITE_ASSET__Bi2c3fFr__"